/* eslint-disable @typescript-eslint/no-require-imports */
import _ from 'lodash';
import qs from 'query-string';
import { getConfigValue } from './config-deprecated';
import { ALLOWED_ABSOLUTE_DOMAIN_ORIGIN } from './constants';

function remotasksURL(path: string, query: string | object = '') {
  return buildURL(getConfigValue('REMOTASKS_FRONTEND_URL'), path, query);
}

function remotasksProdURL(path: string, query: string | object = '') {
  return buildURL(getConfigValue('REMOTASKS_FRONTEND_PROD_URL'), path, query);
}

function outlierURL(path: string, query: string | object = '') {
  return buildURL(getConfigValue('OUTLIER_FRONTEND_URL'), path, query);
}

function cruiseControlURL(path: string, query: string | object = '') {
  return buildURL(getConfigValue('CRUISE_CONTROL_FRONTEND_URL'), path, query);
}

function scaleURL(path: string, query: string | object = '') {
  return buildURL(getConfigValue('SCALE_FRONTEND_URL'), path, query);
}

function scaleDashboardURL(path: string, query: string | object = '') {
  return buildURL(getConfigValue('SCALE_DASHBOARD_FRONTEND_URL'), path, query);
}

function scaleDashboardProdURL(path: string, query: string | object = '') {
  return buildURL(getConfigValue('SCALE_DASHBOARD_FRONTEND_PROD_URL'), path, query);
}

function buildURL(server: string | null | undefined, path: string, query: string | object = '') {
  const baseUrl = `${server || ''}${path}`;
  // if query is a string use it, if it is an object, remove null and
  // undefined keys before turning it into a string
  const queryStr =
    typeof query === 'string' ? query : qs.stringify(_.pickBy(query, x => x != null));

  return queryStr ? `${baseUrl}?${queryStr}` : baseUrl;
}

const EXAMPLE_ORIGIN = 'https://example.test';

/**
 * matches:
 * //google.com
 * /\google.com
 * http:\\google.com
 * http:google.com
 * http://google.com
 * /\t/google.com
 * \tjavascript:doSomethingFunky()
 *
 * allows:
 * /corp/lookup/me?some=param
 * nucleus
 */
function isAbsolute(url: string) {
  return new URL(url, EXAMPLE_ORIGIN).origin !== EXAMPLE_ORIGIN;
}

function ensureRelativeURL(url: string, fallback: string = '/') {
  const u = new URL(url, EXAMPLE_ORIGIN);
  return !_.isString(url) || isAbsolute(url) ? fallback : u.pathname + u.search;
}

function ensureRelativeUrlOrAllowedDomain(url: string) {
  const u = new URL(url, EXAMPLE_ORIGIN);
  if ([...ALLOWED_ABSOLUTE_DOMAIN_ORIGIN, 'outlier.ai'].includes(u.origin)) {
    return url;
  } else {
    return ensureRelativeURL(url);
  }
}

const EMPTY_REDIRECTS = ['', '/', undefined, null];

function coalesceRedirectURL(query: any) {
  const redirectTo = query.redirect_to;
  const redirectUrl = query.redirect_url;

  if (!EMPTY_REDIRECTS.includes(redirectTo)) {
    return redirectTo;
  }

  if (!EMPTY_REDIRECTS.includes(redirectUrl)) {
    return redirectUrl;
  }

  return '/dashboard';
}

export {
  isAbsolute,
  remotasksURL,
  remotasksProdURL,
  cruiseControlURL,
  scaleURL,
  scaleDashboardURL,
  scaleDashboardProdURL,
  buildURL,
  ensureRelativeURL,
  ensureRelativeUrlOrAllowedDomain,
  coalesceRedirectURL,
  outlierURL,
};
